// libraries
import React, { Component } from "react";
import { connect } from "react-redux";
import { get, find, size, map, each, filter } from "lodash";

// components
import Cover from "./index";
import ValidationUtils from "utils/ValidationUtils";
import UI_STRINGS from "utils/stringConstants";

//services
import {
  uploadFile,
  uploadFileToAws
} from "tools/summaryMaker/store/actions/uploadFileActions";

const mapStateToProps = state => {
  const {
    domain: {
      SELECTED_TEMPLATE,
      RECEIVE_TEMPLATE_BLOCKS,
      RECEIVE_BUILD_DOCUMENT_DATA
    },
    SUCCESS_USER_PROFILE
  } = state;

  return {
    ...SELECTED_TEMPLATE,
    ...RECEIVE_TEMPLATE_BLOCKS,
    ...SUCCESS_USER_PROFILE,
    ...RECEIVE_BUILD_DOCUMENT_DATA
  };
};

const mapDispatchToProps = {
  uploadFile,
  uploadFileToAws
};

class CoverPage extends Component {
  state = {
    showPreview: false,
    overlayCoverImage: null,
    coverData: [],
    isCoverImagePresent: false,
    isCustomerNamePresent: false,
    isReportDatePresent: false,
    fields: [],
    documentCoverFields: [],
    imageGallery: [],
    inputFieldGallery: []
  };

  coverImageVariable = false;
  customerNameVariable = false;
  reportDateVariable = false;

  async componentDidMount() {
    await this.props.getActiveDocumentData();
    this.props.handleStateChange({
      key: "isDataEdited",
      value: true
    });
    const currentTab = await this.props.getCurrentTabDetails();
    let { currentDocumentData, ratesWorkBookName } = this.props;
    const { _id: blockId, variables: tabVariables } = currentTab;
    const {
      blocks: {
        cover: { variables: documentVariables }
      }
    } = currentDocumentData;

    const variables = documentVariables ? documentVariables : tabVariables;

    if (!ratesWorkBookName) {
      // get data from redux if not present in container state
      this.props.handleStateChange({
        key: "ratesWorkBookName",
        value: get(
          currentDocumentData,
          `blocks.${get(currentTab, `name`)}.workbookName`
        )
      });
    }

    if (variables) {
      let imageTypeVariables = [];
      let inputTypeVariables = [];

      map(variables, eachVariable => {
        if (eachVariable.type === "image") {
          imageTypeVariables.push(eachVariable);
        } else if (
          eachVariable.type === "string" ||
          eachVariable.type === "date"
        ) {
          inputTypeVariables.push(eachVariable);
        }
      });

      await this.setState({
        imageGallery: imageTypeVariables,
        inputFieldGallery: inputTypeVariables
      });

      size(inputTypeVariables) > 0 && (await this.setDocumentFields());
      size(imageTypeVariables) > 0 && this.fetchCoverImageData(blockId);
    }
  }

  getCurrentDocumentCoverData = async () => {
    await this.props.handleStateChange({
      key: "documentCoverFields",
      value: this.state.fields
    });
  };

  // format fields for the form
  setDocumentFields = async () => {
    let allFields = this.getStaticDocumentFields();

    let fields = map(allFields, eachField => {
      return {
        type:
          get(eachField, `type`) === "string" ? "text" : get(eachField, `type`),
        label: get(eachField, `label`),
        fieldType: get(eachField, `type`) === "string" ? "input" : "textarea",
        value:
          get(eachField, `value.content`) || get(eachField, `value`)
            ? get(eachField, `value`)
            : get(eachField, `defaultValue`),
        _id: get(eachField, `_id`),
        required: get(eachField, `required`)
      };
    });

    await this.setState({
      fields
    });

    this.getCurrentDocumentCoverData();
  };

  handleInputChange = (value, fieldPosition, type) => {
    const { fields } = this.state;
    const { documentCoverFields } = this.props;
    documentCoverFields[fieldPosition].value = value;

    if (
      type !== "date" &&
      documentCoverFields[fieldPosition]._id !== "description"
    ) {
      documentCoverFields[fieldPosition].error = this.handleValidation(value);
    }

    fields[fieldPosition].value = value;
    fields[fieldPosition].edited = true;
    this.setState({
      fields
    });

    this.props.handleStateChange({
      key: "documentCoverFields",
      value: documentCoverFields
    });

    this.props.handleStateChange({
      key: "isDataEdited",
      value: true
    });
  };

  /**
   *handle validation for form fields
   * @returns {String} appropriate error message
   */
  handleValidation = value => {
    if (ValidationUtils.checkIfWhiteSpace(value)) {
      return UI_STRINGS.WHITE_SPACE_ERROR_MESSAGE;
    }
    return null;
  };

  setCoverImageDetails = () => {
    const {
      currentDocumentData: {
        blocks: { cover }
      },
      currentDocumentData,
      coverImageList
    } = this.props;

    let isCoverImageContentPresent = false;

    map(cover.variables, eachVariable => {
      if (eachVariable.type === "image" && eachVariable.content) {
        isCoverImageContentPresent = eachVariable.content;
      }
    });

    if (
      isCoverImageContentPresent &&
      coverImageList &&
      size(coverImageList) > 0
    ) {
      map(coverImageList, eachImage => {
        if (eachImage.url === isCoverImageContentPresent) {
          this.props.handleStateChange({
            key: "selectedCoverLayout",
            value: eachImage._id
          });

          this.props.handleStateChange({
            key: "coverDetails",
            value: eachImage
          });
        }
      });
    } else if (coverImageList && size(coverImageList) > 0) {
      this.props.handleStateChange({
        key: "selectedCoverLayout",
        value: coverImageList[0]._id
      });

      this.props.handleStateChange({
        key: "coverDetails",
        value: coverImageList[0]
      });

      this.props.handleStateChange({
        key: "isDataEdited",
        value: true
      });
    }
  };

  /**
   *  gives all the fields for the document along with name and description
   *
   * @memberof DocumentPage
   * @returns {Array} consists of all the dynamic fields along with static ones
   */
  getStaticDocumentFields = () => {
    let { inputFieldGallery } = this.state;

    // these fields will always be displayed
    let staticDocumentFields = [];

    if (size(inputFieldGallery) > 0) {
      map(inputFieldGallery, eachInputField => {
        eachInputField.type !== "date"
          ? staticDocumentFields.push({
              _id: eachInputField._id,
              label: eachInputField.label,
              type: eachInputField.type,
              defaultValue: eachInputField.defaultValue,
              required: eachInputField.required,
              value: eachInputField.content ? eachInputField.content : ""
            })
          : staticDocumentFields.push({
              _id: eachInputField._id,
              label: eachInputField.label,
              type: "date",
              required: eachInputField.required,
              value: eachInputField.content
                ? eachInputField.content
                : new Date()
            });
      });
    }

    let allFields = [...staticDocumentFields];

    // setting default date for all date fields
    each(allFields, eachField => {
      if (get(eachField, `type`) === "date" && !!!get(eachField, `value`)) {
        eachField.value = new Date();
      }
    });

    return allFields;
  };

  fetchCoverImageData = async blockId => {
    await this.props.handleStateChange({
      key: "coverImageVariableId",
      value: this.state.imageGallery[0]._id
    });

    const {
      selectedTemplate: { _id: templateId }
    } = this.props;

    if (blockId && templateId) {
      // This updates the redux store key. 
      // getCoverData is a generic function that fetches the value
      // content Blocks but we need an identifier as it is updating
      // the key in the redux store for pptTemplate as well
      await this.props.getCoverData(blockId, templateId, "pptTemplate");
      const { coverBlockData } = this.props;

      this.props.handleStateChange({
        key: "coverImageList",
        value: coverBlockData ? coverBlockData : []
      });

      coverBlockData && size(coverBlockData) > 0 && this.setCoverImageDetails();
    }
  };

  handleCoverPreview = (imgSrc = "") => {
    this.setState({
      showPreview: !this.state.showPreview,
      overlayCoverImage: imgSrc
    });
  };

  uploadFileToRepo = async ({ metaDeta, file }, cb) => {
    const templateBlocks = get(this.props, `selectedTemplate.blocks`) || [];
    const userId = get(this.props, `userProfileMeta._id`);
    const documentId = get(this.props, `currentDocumentData._id`);
    const contentBlockId = (
      find(templateBlocks, eachBlock => {
        return eachBlock.type === "datatable";
      }) || {}
    )._id;

    delete metaDeta.resource;
    delete metaDeta.title;

    let postData = {
      ...metaDeta,
      fileType: "excel",
      name: get(metaDeta, `fileName`)
    };

    let response = await this.props.uploadFile(
      userId,
      postData,
      documentId,
      contentBlockId
    );

    let { presignedUrl = "" } = get(response, `data`);
    await this.props.uploadFileToAws(presignedUrl, file);

    // empty previewPageDetails to again start build
    this.props.handleStateChange({
      key: "previewPageDetails",
      value: []
    });

    cb();

    this.props.handleStateChange({
      key: "ratesWorkBookName",
      value: postData.name
    });
  };

  render() {
    /** Merge States and Methods */
    const stateMethodProps = {
      ...this,
      ...this.state,
      ...this.props
    };

    return <Cover {...stateMethodProps} />;
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(CoverPage);
